










































































import { Component, Vue, Mixins, Watch } from 'vue-property-decorator'
import Template from '../../mixins/Template.vue'

@Component
export default class Steps extends Mixins(Template) {
  public active: boolean = false

  /**
   * Animate.
   */
  @Watch('$route')
  public animate() {
    this.active = false
    setTimeout(() => {
      this.active = true
    })
  }

  /**
   * On mounted.
   */
  mounted() {
    this.animate()
  }
}
